import { CmsSystem } from '@cbgms/api/modules/enums'

export const CMSSYSTEMVALUES = [
  { key: CmsSystem.Raw, value: CmsSystem.Raw, text: 'raw' },
  { key: CmsSystem.WordPress, value: CmsSystem.WordPress, text: 'wordpress' },
  { key: CmsSystem.DrupalJSONAPI, value: CmsSystem.DrupalJSONAPI, text: 'drupal_jsonapi' }
]
